var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`${_vm.home ? 'avatar-home' : ''}`},[_c('vs-avatar',{attrs:{"size":_vm.size,"circle":""}},[_c('img',{attrs:{"src":this.avatarUrl_}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }